import { cn } from '@/lib/utils';

import { getBrandTileIcon } from './brand-tile-icons';
import { getBrandIcon, getIntegrationIcon } from './integration-icons';

const getVectorIcon = (name: string) =>
  getBrandIcon(name) ?? getBrandTileIcon(name);

export const IntegrationIcon = ({
  iconKey,
  iconUrl,
  name = iconKey,
  className,
}: {
  iconKey: string;
  iconUrl?: string | null;
  name?: string;
  className?: string;
}) => {
  const Icon = getVectorIcon(iconKey) ?? getVectorIcon(name);
  if (Icon) return <Icon className={className} />;
  if (iconUrl) {
    return (
      <img
        src={iconUrl}
        alt=""
        className={cn('shrink-0 object-contain', className)}
      />
    );
  }
  const Monogram = getIntegrationIcon(name);
  return <Monogram className={className} />;
};
